import $ from 'jquery'

$(document).ready(function() {
  co_vc_lieferanten()
})

function co_vc_lieferanten() {
  $('.co_vc_lieferanten').each(function() {})
}
